import { formatCurrency } from '../../utils/formatCurrency';
import { globals } from 'common-ui';
import type { ProductCardProps } from './ProductCard';

const ProductCardPrice = (props: ProductCardProps) => {
  const { productPrice, productPriceOriginal, productNumberOfBottles, productMemberPrice } = props || {};

  return (
    <>
      <div className="product-price body1">
        {productNumberOfBottles && productNumberOfBottles !== 0 ? (
          <span className="product-card__bottles">
            {productNumberOfBottles} bottle{`${productNumberOfBottles > 1 ? 's :' : ' :'}`}
          </span>
        ) : (
          ''
        )}
        {productPrice !== null && productPrice !== undefined && (
          <>
            {productPriceOriginal !== null && productPriceOriginal !== undefined && productPriceOriginal !== 0 ? (
              <s className="product-price__original">{formatCurrency(productPriceOriginal)}</s>
            ) : null}
            <span className="body1 bold">{formatCurrency(productPrice)}</span>
          </>
        )}
      </div>

      {productMemberPrice && productMemberPrice !== 0 ? (
        <span className="product-card__member-price body1 bold">
          {formatCurrency(productMemberPrice)} {globals?.brandId === 'wsj' ? 'Advantage' : 'Unlimited'} Member Price
        </span>
      ) : (
        ''
      )}
    </>
  );
};

export default ProductCardPrice;
